export default __webpack_public_path__ + "static/media/topomap_absolute_eeg.de59ece0.webp";